import * as React from 'react';
import * as styled from './styled';
import Switch, {SwitchVariant} from 'components/Switch';
import {
  IsToggle,
  Content,
  UseGroupWeekProps,
  UseGroupWeekReturn,
} from './types';

/**
 *
 * @param {UseGroupWeekProps | undefined} props
 * @return {UseGroupWeekReturn}
 */
export default function useGroupWeek(
    props?: UseGroupWeekProps,
): UseGroupWeekReturn {
  const [
    isToggle, setToggle,
  ] = React.useState<IsToggle>(
      props?.initialToggle || true,
  );

  /**
   * Change toggle state.
   * @return {void}
   */
  function changeToggle(): void {
    setToggle(!isToggle);
  }

  /**
   * Render control.
   * @return {JSX.Element}
   */
  function renderControl(): JSX.Element {
    /**
     * The change event handler.
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
      setToggle(event.target.checked);
    }

    return (
      <Switch
        checked={isToggle}
        label="Группировать по неделям"
        variant={SwitchVariant.Accent}
        onChange={handleChange}
      />
    );
  }

  /**
   * Wrap the content.
   * @param {Content} content
   * @return {Content}
   */
  function wrapContent(
      content: Content,
  ): Content {
    /**
     * Render month label.
     * @param {number} index
     * @return {JSX.Element | undefined}
     */
    function renderLabel(index: number): JSX.Element | undefined {
      return isToggle && (index !% 7 === 0) ? (
        <styled.LabelWrapper>
          <styled.LabelContent>
            {`${(index / 7) + 1} неделя`}
          </styled.LabelContent>
        </styled.LabelWrapper>
      ) : undefined;
    }

    return Array.isArray(content) ? (
      content.map((content, index) => (
        <div key={index}>
          {renderLabel(index)}
          {content}
        </div>
      ))
    ) : content;
  }

  return {
    isToggle,
    renderControl,
    wrapContent,
  };
}
